<script>
import { authComputed } from '@state/helpers'
import { personalMoodCapture } from '@services/safehaven/PersonalMessageService'
import store from '@state/store'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
import { GREAT_MOOD, JUST_OK_MOOD, BAD_MOOD } from '@constants/mood'

export default {
  mixins: [NavigateMixin],
  props: {
    id: { type: String, required: true },
    title: { type: String, required: true },
    felling: { type: Array, required: true },
  },

  data() {
    return {
      frequencyset: false,
      dialog: false,
      detailsAreVisible: true,
      GREAT_MOOD,
      JUST_OK_MOOD,
      BAD_MOOD,
      textGreat: 'Fantastic! That’s great news. Have a good day!',
      textOk: 'Just OK? Stay positive and your day will get better.',
      textBad: 'Hmm, you’re feeling bad? Would you like some help with that?',
      textHelp: 'Which of the following are you experiencing?',
      textHealthChecker:
        'OK, let’s evaluate your symptoms and get you pointed in the right direction.',
      textDepressionAssessment:
        'OK, let’s have you take a brief depression assessment to see how we can help you.',
      textHealthHelp: 'OK, let’s get you over to HB+ Help',
      isShowMessageDialog: false,
      timeout: 3000,
      answersData: {
        user_id: this.userId,
        user_mood: '',
      },
      isInsomnia: false,
      messageStatus: '',
    }
  },
  computed: {
    ...authComputed,
  },
  async mounted() {
    // Get User Data

    const userData = JSON.parse(localStorage.getItem('auth.currentUser'))
    this.answersData.user_id = userData.user.user_id
    this.frequencyset = userData.user.is_mood_captured
    this.isInsomnia = userData.user.insomnia_status
  },
  methods: {
    navigate() {
      this.dialog = false
      if (this.isInsomnia) {
        this.updateInsomnia()
      }
      this.detailsAreVisible = !this.detailsAreVisible
      store.dispatch('personalMessages/setPersonalMessage', this.messageStatus)
      this.$router.push({
        name: 'health-help',
        params: { resultMessage: null },
      })
    },
    openNewIsabelSymptomChecker() {
      window.open(
        'https://symptomchecker.isabelhealthcare.com/index.jsp?passcode=CJK0Xj6NCaVeDIp6tpK3op7Q4Yl5Kv2S'
      )
    },
    closemessage() {
      personalMoodCapture.saveMood(this.answersData).then((response) => {})
      this.detailsAreVisible = !this.detailsAreVisible

      this.answersData.user_mood = 'Closed'
      personalMoodCapture.saveMood(this.answersData).then((response) => {
        if (response.status === 200) {
        }
      })
    },
    closeMessageDialog() {
      this.isShowMessageDialog = false
      this.detailsAreVisible = !this.detailsAreVisible
    },
    hideMessageForToday() {
      this.updateInsomnia()
      this.detailsAreVisible = !this.detailsAreVisible
    },
    updateInsomnia() {
      personalMoodCapture.saveInsomnia().then((res) => {
        this.isInsomnia = false
      })
    },
    showMessage(status) {
      switch (status) {
        case GREAT_MOOD:
        case JUST_OK_MOOD:
        case BAD_MOOD:
          this.saveStatus(status)
          this.messageStatus = status
          this.isShowMessageDialog = true
          break
        case 'No-Help':
          this.messageStatus = status
          this.closeMessageDialog()
          break
        case 'GoHealthChecker':
          this.messageStatus = status
          this.closeMessageDialog()
          setTimeout(() => this.openNewIsabelSymptomChecker(), 500)
          break
        case 'GoDepressionAssessment':
          this.messageStatus = status
          this.closeMessageDialog()
          this.$router.push({
            name: 'quetionnaire',
          })
          break
        case 'GoHealthHelp':
          this.messageStatus = status
          this.closeMessageDialog()
          this.$router.push({
            name: 'safehaven-health-help',
          })
          break
        default:
          this.messageStatus = status
          this.isShowMessageDialog = true
          break
      }
    },
    saveStatus(status) {
      let savingStatus = BAD_MOOD
      if (status === GREAT_MOOD || status === JUST_OK_MOOD) {
        savingStatus = status
      }
      this.answersData.user_mood = savingStatus
      personalMoodCapture.saveMood(this.answersData).then((response) => {
        if (response.status === 200) {
          if (status === GREAT_MOOD) {
            setTimeout(() => {
              store.dispatch('personalMessages/setPersonalMessage', status)
            }, 3000)
          } else if (status === JUST_OK_MOOD) {
            setTimeout(() => {
              store.dispatch('personalMessages/setPersonalMessage', status)
            }, 3000)
          }
          return response.data
        }
      })
    },
  },
}
</script>

<template>
  <div v-if="detailsAreVisible">
    <div v-if="detailsAreVisible && isInsomnia" :class="$style.message">
      <v-btn
        :ripple="false"
        right
        absolute
        icon
        :class="$style.btnClass"
        @click="closemessage"
      >
        <v-icon color="#8F8F8F80">mdi-close</v-icon>
      </v-btn>
      <v-row no-gutters class="py-4 px-7" align="center">
        <v-col
          cols="12"
          md="8"
          lg="7"
          xl="5"
          class="py-2"
          :class="$style.title"
        >
          We noticed you have an irregular sleep pattern, would you like some
          help?
        </v-col>
        <v-col cols="12" md="4" lg="5" xl="7" class="py-2" align-self="center">
          <div :class="$style.mobilePosition" class="ml-3">
            <v-btn
              class="mr-2"
              :class="$style.insomniaBtn"
              @click="hideMessageForToday"
              >No</v-btn
            >
            <v-btn :class="$style.insomniaBtn" @click="navigate">Yes</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <div
      v-else-if="detailsAreVisible && !isInsomnia && !frequencyset"
      class="pt-5"
      :class="$style.message"
    >
      <v-btn
        :ripple="false"
        right
        absolute
        icon
        :class="$style.btnClass"
        @click="closemessage"
      >
        <v-icon color="#8F8F8F80">mdi-close</v-icon>
      </v-btn>

      <v-col no-gutters class="py-4 px-7" justify="center">
        <v-row
          cols="12"
          md="4"
          lg="3"
          xl="2"
          class="py-2 px-4"
          :class="$style.title"
        >
          <span>Welcome {{ currentUser.user.first_name }}!</span>
          <span> {{ title }}</span>
        </v-row>
        <v-row
          cols="12"
          md="10"
          lg="10"
          xl="10"
          class="py-2 mt-0"
          align-self="center"
        >
          <div :class="$style.mobilePosition" class="ml-3">
            <v-row
              v-for="(fell, index) in felling"
              :key="'personal-message-' + index"
              style="margin-top: 5px"
              :class="$style.iconBox"
              @click="showMessage(fell.status)"
            >
              <img
                v-if="fell.Isicon === true"
                :src="fell.icon"
                width="20"
                class="mr-1"
              />
              <div :class="$style.iconBoxText">{{ fell.status }}</div>
            </v-row>
          </div>
        </v-row>
      </v-col>
    </div>

    <v-dialog v-model="isShowMessageDialog" max-width="320px" persistent>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            :ripple="false"
            right
            absolute
            icon
            :class="$style.btnClass"
            @click="closeMessageDialog"
          >
            <v-icon color="#6B7280">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-4 pb-3">
          <div v-if="messageStatus === GREAT_MOOD">
            <div class="d-flex flex-column align-center mt-10">
              <img
                :src="
                  require('@assets/images/safehaven/dashboard/fantastic.svg')
                "
                width="100"
              />
              <p :class="[$style.alertMsg, $style.great, 'pt-5 px-10']">
                {{ textGreat }}</p
              >
            </div>
          </div>
          <div v-else-if="messageStatus === JUST_OK_MOOD">
            <div class="d-flex flex-column align-center mt-10">
              <img
                :src="require('@assets/images/safehaven/dashboard/just-ok.svg')"
                width="100"
              />
              <p :class="[$style.alertMsg, $style.ok, 'pt-5 px-12']">
                {{ textOk }}</p
              >
            </div>
          </div>
          <div v-else-if="messageStatus === BAD_MOOD">
            <div class="d-flex flex-column align-center mt-10 mb-3">
              <p :class="[$style.alertMsg, $style.msgContent]">
                {{ textBad }}</p
              >
            </div>
            <div class="d-flex justify-space-between">
              <v-btn
                :class="$style.yesNoButton"
                class="pa-0"
                outlined
                @click="showMessage('No-Help')"
              >
                No, thanks
              </v-btn>
              <v-btn
                :class="$style.yesNoButton"
                class="pa-0"
                outlined
                @click="showMessage('Yes-Help')"
              >
                Yes, I need help
              </v-btn>
            </div>
          </div>
          <div v-else-if="messageStatus === 'Yes-Help'">
            <div class="d-flex flex-column align-center mt-10 mb-3">
              <p :class="[$style.alertMsg, $style.msgContent]">
                {{ textHelp }}</p
              >
            </div>
            <div class="d-flex flex-column">
              <v-btn
                :class="$style.dialogButton"
                class="pa-0"
                outlined
                @click="showMessage('HealthChecker')"
              >
                I’ve got physical symptoms
              </v-btn>
              <v-btn
                :class="$style.dialogButton"
                class="pa-0"
                outlined
                @click="showMessage('DepressionAssessment')"
              >
                I’m feeling down
              </v-btn>
              <v-btn
                :class="$style.dialogButton"
                class="pa-0"
                outlined
                @click="showMessage('HealthHelp')"
              >
                I’m experiencing anxiety
              </v-btn>
            </div>
          </div>
          <div v-else-if="messageStatus === 'HealthChecker'">
            <div class="d-flex flex-column align-center mt-10 mb-3">
              <p :class="[$style.alertMsg, $style.msgContent]">
                {{ textHealthChecker }}</p
              >
            </div>
            <div class="d-flex">
              <v-btn
                :class="$style.navigateButton"
                class="pa-0"
                outlined
                @click="showMessage('GoHealthChecker')"
              >
                <v-icon :class="[$style.navigateBtnImg]" left
                  >mdi-arrow-right</v-icon
                >
                Start Health Checker
              </v-btn>
            </div>
          </div>
          <div v-else-if="messageStatus === 'DepressionAssessment'">
            <div class="d-flex flex-column align-center mt-10 mb-3">
              <p :class="[$style.alertMsg, $style.msgContent]">
                {{ textDepressionAssessment }}</p
              >
            </div>
            <div class="d-flex">
              <v-btn
                :class="$style.navigateButton"
                class="pa-0"
                outlined
                @click="showMessage('GoDepressionAssessment')"
              >
                <v-icon :class="[$style.navigateBtnImg]" left
                  >mdi-arrow-right</v-icon
                >
                Take Depression Assessment
              </v-btn>
            </div> </div
          ><div v-else-if="messageStatus === 'HealthHelp'">
            <div class="d-flex flex-column align-center mt-10 mb-3">
              <p :class="[$style.alertMsg, $style.msgContent]">
                {{ textHealthHelp }}</p
              >
            </div>
            <div class="d-flex">
              <v-btn
                :class="$style.navigateButton"
                class="pa-0"
                outlined
                @click="showMessage('GoHealthHelp')"
              >
                <v-icon :class="[$style.navigateBtnImg]" left
                  >mdi-arrow-right</v-icon
                >
                Visit HB+ Help
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.buttonwrapp {
  display: flex;
  justify-content: center;
}
.great {
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  color: #3d3d3d;
  text-align: left;
  letter-spacing: 0;
}

.ok {
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: #3d3d3d;
  text-align: left;
  letter-spacing: 0;
}

.insomniaBtn {
  color: #082787 !important;
  text-transform: capitalize;
  background-color: #fff !important;
  border: 1px solid #082787 !important;
  box-shadow: none;
}

.message {
  background-color: #cff8ff;
  border-bottom: 2px solid #fff;
}

.iconBoxText {
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: #082787;
  text-align: center;
  letter-spacing: 0;
}

.btnClass {
  top: 10px;
  right: 10px !important;
}

.iconBox {
  align-items: center;
  justify-content: center;
  float: left;
  width: 100px;
  padding-top: 10px;
  padding-right: 5px;
  padding-bottom: 10px;
  padding-left: 5px;
  margin-right: 4px;
  margin-bottom: 25px;
  margin-left: 4px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  background: #fff;
  border: 1px solid #082787;
  border-radius: 4px;
}

.title {
  display: initial;
  flex-direction: row;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  text-align: left;
  letter-spacing: 0.5px;
}

.alertContainer {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-height: 50px;
  padding: 3px 10px;
  margin-top: 15px;
  margin-bottom: 15px;
  margin-left: 2px;
  border: none !important;
}

.alertMsg {
  padding: 2px;
  text-align: center;
}
.msgContent {
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: #1f2937;
}

.hiddenButton {
  display: none;
}
.dialogButton {
  width: 100%;
  height: 40px;
  margin: 6px 0;
  font-size: 14px;
  color: #082787 !important;
  text-transform: none;
  border: 1px solid #082787;
}
.yesNoButton {
  width: 136px;
  height: 40px;
  font-size: 14px;
  color: #082787 !important;
  text-transform: none;
  border: 1px solid #082787;
}
.navigateButton {
  width: 100%;
  height: 40px;
  margin: 6px 0;
  font-size: 14px;
  color: #fff !important;
  text-transform: none;
  background: linear-gradient(180deg, #84b25a 0%, #698e48 100%);
  border: none;
}
.navigateBtnImg {
  width: 20px;
  height: 20px;
  margin-right: 4px;
}
.dialogText {
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
  letter-spacing: 0;
  word-wrap: break-word;
}

@media screen and (max-width: 959px) {
  .title {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    margin-bottom: 15px;
    font-size: 26px;
    line-height: 30px;
    text-align: center;
  }
  .mobilePosition {
    display: flex;
    justify-content: center;
    padding: 0 20px;
  }
  .message {
    padding: 0 0 20px;
  }
  .iconBox:first-child {
    margin-left: 0;
  }
}
</style>
